window.FreteOrcamentoController = ControllerBase.extend({
    framework: "knockout",
    name: "FreteOrcamentoController",

    ajax: function() {

        return {
            url: "/Orcamento/_Frete",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    initialize: function() {
        parametroSistema.obter("UTILIZA_FRETE_CARGA",
            $.proxy(function(p) {
                if (p.Valor === "S") {
                    this.orcamento.on("change:ValorFrete", this.valorFreteAlterado, this);
                }
            }, this));
    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    dispose: function() {
        this.orcamento.off(null, this.valorFreteAlterado, this);
    },

    atualizarBotoes: function() {
        this.renderActionButtons();
    },

    valorFreteAlterado: function() {
        this.pesquisar(1);
    },

    carregarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-frete",
            data: data,
            pageClickCallback: $.proxy(self.paginar, self)
        });
    },

    paginar: function(e) {
        this.pesquisar(e.page);
    },

    pesquisar: function(pagina) {

        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: pagina ? pagina : 1,
            IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
        };

        var self = this;

        global.ajax({
            url: "/Orcamento/ListarFretes",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);

                self.model.Fretes(m());
                self.carregarPaginador(data);
            }
        });

    },

    editar: function(model) {

        this.editarFreteController = this.showView({
            region: {
                name: "editarFreteRegion",
                selector: "#editar-frete-region"
            },
            model: model,
            controller: {
                type: EditarFreteController,
                args: {
                    orcamento: this.orcamento,
                    finalizarCallback: $.proxy(this.finalizarEdicao, this),
                    readOnly: this.readOnly
                }
            }
        });
    },

    finalizarEdicao: function() {
        this.editarFreteController.hide();
    }

});